import { cn } from '@playbooks/ui/lib/utils';

const AgentDesignPalette = ({ colors = [], limit = 5 }) => {
	const palette = (Array.isArray(colors) ? colors : [])
		.flatMap(color => {
			if (color && typeof color === 'object') return [color];
			if (typeof color !== 'string') return [];
			try {
				const parsed = JSON.parse(color);
				return parsed && typeof parsed === 'object' ? [parsed] : [];
			} catch {
				return [];
			}
		})
		.slice(0, limit);
	if (!palette.length) return null;
	return (
		<span
			role='img'
			className='flex shrink-0 items-center pl-1'
			aria-label={palette.map(color => `${color.name}: ${color.value}`).join(', ')}>
			{palette.map((color, index) => (
				<span
					key={`${color.name}-${color.value}`}
					className={cn('size-4 rounded-full border border-border-strong shadow-inner dark:border-canvas', {
						'-ml-1': index > 0,
					})}
					data-overlap={index > 0 || undefined}
					style={{ backgroundColor: color.value }}
					title={`${color.name}: ${color.value}`}
					aria-hidden
				/>
			))}
		</span>
	);
};

export { AgentDesignPalette };
